import { login, PWA_FROM_QR_QUERY_PARAM, PWA_FROM_QR_VALUE } from '../pages/paths';

export interface BeforeInstallPromptEvent extends Event {
    prompt: () => Promise<void>;
    userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export const getHashSearchParams = (): URLSearchParams => {
    const hash = window.location.hash || '';
    const queryIndex = hash.indexOf('?');

    if (queryIndex === -1) {
        return new URLSearchParams();
    }

    return new URLSearchParams(hash.substring(queryIndex + 1));
};

export const isQrCodeEntry = (): boolean => {
    const fromHash = getHashSearchParams().get(PWA_FROM_QR_QUERY_PARAM);
    if (fromHash === PWA_FROM_QR_VALUE) {
        return true;
    }

    const fromSearch = new URLSearchParams(window.location.search).get(PWA_FROM_QR_QUERY_PARAM);
    return fromSearch === PWA_FROM_QR_VALUE;
};

export const isStandalonePwa = (): boolean => {
    return (
        window.matchMedia('(display-mode: standalone)').matches ||
        (window.navigator as Navigator & { standalone?: boolean }).standalone === true
    );
};

export const isIosDevice = (): boolean => {
    return /iphone|ipad|ipod/i.test(navigator.userAgent);
};

/** Public URL of the backoffice (hash-router login page) for QR codes and sharing. */
export const getBackofficePublicUrl = (): string => {
    const { origin, pathname } = window.location;
    const normalizedPath = pathname === '/' ? '' : pathname.replace(/\/$/, '');
    const hashRoute = login.startsWith('/') ? login : `/${login}`;

    return `${origin}${normalizedPath}#${hashRoute}?${PWA_FROM_QR_QUERY_PARAM}=${PWA_FROM_QR_VALUE}`;
};

export const clearQrEntryParam = (): void => {
    const hash = window.location.hash;

    if (!hash.includes('?')) {
        return;
    }

    const [path, query] = hash.split('?');
    const params = new URLSearchParams(query);
    params.delete(PWA_FROM_QR_QUERY_PARAM);

    const newQuery = params.toString();
    const newHash = newQuery ? `${path}?${newQuery}` : path;

    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${newHash}`);
};
